export default "__VITE_ASSET__9a9a2ffa__"